<template>
  <div class="grey lighten-2" style="min-height: 100%">
    <v-container grid-list-lg>
      <div class="text-xs-right">
        <v-btn icon @click="$emit('update:opened', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-layout row wrap>
        <v-flex xs12 v-if="description || loadingHelp">
          <v-card color="white" class="grey--text text--darken-3" flat v-if="!loadingHelp">
            <v-card-title primary-title>
              <div class="Medium">
                <v-icon large>description</v-icon>
                Presentation
              </div>
              <v-card-text v-html="description">{{ description }}
              </v-card-text>
            </v-card-title>
            <v-expansion-panel>
              <v-expansion-panel-content v-if="lexique">
                <div slot="header">{{ $t('lexique') }}</div>
                <v-card>
                  <v-card-text v-html="lexique" class="grey lighten-3">{{ lexique }}</v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content v-if="video">
                <div slot="header">Video</div>
                <v-card>
                  <v-card-text class="grey lighten-3" v-if="youtube===0">
                    <video controls alt="presentation" :src="video" :poster="videoposter" playsinline="" style="width:260px; height:auto; left: 0px; top: 0px;"></video>
                  </v-card-text>
                  <v-card-text class="grey lighten-3" v-else>
                    <iframe :src="video" :poster="videoposter" width="260" frameborder="0" style="width:260px; height:auto; left: 0px; top: 0px;" allowfullscreen="allowfullscreen"></iframe>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card>
          <v-card v-else>
            <v-card-text class="text-xs-center">
              <v-progress-circular indeterminate class="primary--text" :size="50" :width="1"></v-progress-circular>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 >
          <v-card color="white" class="grey--text text--darken-3" flat>
            <v-card-title>
              <div class="Medium">
                <v-icon large>book</v-icon> 
                {{ $t('knowledgeBase') }}
              </div>
              <div>
                <a :href="'https://support.targetfirst.com'" target="_blank">
                  {{ $t('ourKnowledgeBase') }}
                </a>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 >
          <v-card color="white" class="grey--text text--darken-3" flat>
            <v-card-title>
              <div class="Medium">
                <v-icon large>school</v-icon>
                Webinar
              </div>
              <div>
                <a :href=" 'https://www.targetfirst.com/prenez-rendez-vous-prise-en-main/'" target="_blank">
                  {{ $t('signUpWebinar') }}
                </a>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 >
          <v-card color="white" class="grey--text text--darken-3" flat v-if="emailSupportSend == true ">
           <v-card-title>
            <div class="Medium">
              <v-icon large>mail_outline</v-icon>
              {{ $t('contactTheSupport') }}
            </div>
          </v-card-title>
          <v-card-text class="grey lighten-3">{{ $t('emailSent') }}</v-card-text>
        </v-card>
        <v-card color="white" class="grey--text text--darken-3" flat v-if="emailSupportSend == false">
          <v-card-title>
            <div class="Medium">
              <v-icon large>mail_outline</v-icon>
              {{ $t('contactTheSupport') }}
            </div>
          </v-card-title>

          <v-form>
            <v-card-text>
              <v-text-field
              :label="$t('subject') | cap"
              v-model="subject"
              ></v-text-field>
              <v-textarea
              :label="$t('typeYourMessage') | cap"
              v-model="message"
              required
              ></v-textarea></v-card-text>
              <v-card-actions>
                <v-btn block color="primary" @click="send()" :loading="loadingMail">
                  {{ $t('send') }}
                  <v-icon right>send</v-icon>
                </v-btn>
              </v-card-actions>
            </v-form>

          </v-card>
        </v-flex>
        <v-flex xs12 >
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'help',
  props: {
    opened: {
      type: Boolean, // String, Number, Boolean, Function, Object, Array
      required: true
    }
  },
  data () {
    return {
      description: '',
      lexique: '',
      video: '',
      videoposter: '',
      subject: '',
      message: '',
      currentRoute: '',
      loadingMail: false,
      loadingHelp: false,
      emailSupportSend: false,
      youtube: 0
    }
  },
  computed: {
    ...mapState('_User', ['fullName', 'domain', 'mailContact']),
    ...mapGetters('_User', ['fullName']),
    ...mapState('_Sites', ['siteSelected'])
  },
  methods: {
    getHelp (r) {
      this.loadingHelp = true
      this.axios
        .get(
          'get/help.php?route=' + encodeURI(r) + '&lang=' + this.$i18n.locale
        )
        .then(res => {
          this.description = res.data.description
          this.lexique = res.data.lexique
          this.video = res.data.video
          this.videoposter = res.data.videoposter
          this.youtube = res.data.youtube
        })
        .catch(err => {
          console.log(err)
        })
        .then(() => {
          this.loadingHelp = false
        })
    },
    send () {
      // pas de ticket si pas de message
      if (!this.message.trim().length) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$tc('messages', 0),
          context: 'warning'
        })
        return
      }
      let dataToPost = new window.FormData()
      dataToPost.append('to', 'support@targetfirst.com')
      dataToPost.append('ReplyTo', this.mailContact)
      dataToPost.append('fullName', this.fullName)
      dataToPost.append('siteSelected', this.siteSelected.LIC_URL)
      dataToPost.append('subject', this.subject)
      dataToPost.append('title', 'Demande de support')
      dataToPost.append('message', this.message)
      dataToPost.append('url', this.$route.fullPath)
      this.loadingMail = true
      this.axios
        .post('post/email_support.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(res => {
          this.emailSupportSend = true
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('emailSent'),
            context: 'success'
          })
        })
        .catch(() => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('emailFailure'),
            context: 'error'
          })
        })
        .then(() => {
          this.loadingMail = false
        })
    }
  },
  watch: {
    opened: function (v) {
      if (v && this.currentRoute !== this.$route.fullPath) {
        this.emailSupportSend = false
        this.subject = ''
        this.message = ''
        this.currentRoute = this.$route.fullPath
        this.getHelp(this.$route.fullPath)
      }
    }
  }
}
</script>

<style lang="css">
.navigation-drawer {
  padding-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzHelp.vue